<div class="modal-body">
	<div class="row">
		<div class="col-12 d-flex justify-content-between align-items-center">
			<p class="header-text poppins uppercase">UPDATE {{ league?.name }}</p>
			<img src="assets/img/shared/close-icon.svg" class="close-icon pointer" alt="" (click)="close()">
		</div>
		<div class="col-12">
			<p class="sub-text">Enter league details</p>
		</div>
	</div>
  
	<form [formGroup]="form"> 
		<div class="row">
			<div class="col-6">
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<input matInput type="text" placeholder="League Name" formControlName="name">
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline">
							<input matInput [matDatepicker]="pickerStart" placeholder="Start Date" formControlName="leagueStart" [min]="dateToday" readonly>
							<mat-datepicker-toggle matSuffix [for]="pickerStart">
								<mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
							</mat-datepicker-toggle>
							<mat-datepicker #pickerStart></mat-datepicker>
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" >
							<input matInput [matDatepicker]="pickerEnd" placeholder="End Date" formControlName="leagueEnd" [min]="dateToday" readonly>
							<mat-datepicker-toggle matSuffix [for]="pickerEnd">
								<mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
							</mat-datepicker-toggle>
							<mat-datepicker #pickerEnd></mat-datepicker>
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" >
							<input matInput [matDatepicker]="pickerDeadline" placeholder="Deadline Date" formControlName="leagueDeadline" readonly>
							<mat-datepicker-toggle matSuffix [for]="pickerDeadline">
								<mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
							</mat-datepicker-toggle>
							<mat-datepicker #pickerDeadline></mat-datepicker>
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline">
							<mat-select placeholder="League Open" formControlName="leagueOpen">
								<mat-option value="yes">Yes</mat-option>
								<mat-option value="no">No</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<input matInput type="number" placeholder="Number of rounds" formControlName="leagueRound" min="0">
						</mat-form-field>
					</div>
				</div>
			</div>
			<div class="col-6">
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<input matInput type="number" placeholder="Rating Mininum" formControlName="ratingMinimum" min="0">
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<input matInput type="number" placeholder="Rating Maximum" formControlName="ratingMaximum" min="0">
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline">
							<mat-select placeholder="Players" formControlName="players">
								<mat-option value="8">8</mat-option>
								<mat-option value="16">16</mat-option>
								<mat-option value="32">32</mat-option>
								<mat-option value="64">64</mat-option>
								<mat-option value="128">128</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" >
							<mat-select placeholder="Category" formControlName="leagueCategory">
								<mat-option value="national">National</mat-option>
								<mat-option value="regional">Regional</mat-option>
								<mat-option value="provincial">Provincial</mat-option>
								<mat-option value="divisional">Divisional</mat-option>
								<mat-option value="institutional">Institutional</mat-option>
								<mat-option value="open">Open</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" >
							<mat-select placeholder="Game Type" formControlName="leagueType">
								<mat-option value="basic">Basic</mat-option>
								<mat-option value="epic">Epic</mat-option>
								<mat-option value="legendary">Legendary</mat-option>
								<mat-option value="mythical">Mythical</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>

		<div class="row mt-20">
			<div class="col-12 d-flex justify-content-center">
				<button class="btn create poppins" type="button" (click)="createSeasonLeague()">Update</button>  
			</div>
		</div>
	</form>
</div>  